/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import React from 'react';

import { cssMap as cssMapCompiled, jsx } from '@compiled/react';
import { FormattedMessage, useIntl } from 'react-intl-next';

import { ErrorMessage, HelperMessage } from '@atlaskit/form';
import EditorInfoIcon from '@atlaskit/icon/core/status-information';
import { fg } from '@atlaskit/platform-feature-flags';
import { token } from '@atlaskit/tokens';
import Tooltip from '@atlaskit/tooltip';

import { messages } from '../i18n';

import * as Styled from './styled';

// TODO: After ptc-people-teams-migrate-styled-components FF cleanup:
// - Remove wrapper pattern (fg() conditionals) and use css={} directly
// - Remove Styled imports and styled.ts references
const compiledStyles = cssMapCompiled({
	infoPopupLearnMoreWrapper: {
		display: 'block',
		marginTop: token('space.100'),
	},
	divWrapper: {
		display: 'flex',
		alignItems: 'center',
	},
	infoIconWrapper: {
		margin: 0,
		marginLeft: token('space.050'),
		maxHeight: token('space.200'),
	},
});
export function InfoDetailLearnMoreLink(): React.JSX.Element {
	// TODO: Remove wrapper after ptc-people-teams-migrate-styled-components FF cleanup
	const InfoPopupLearnMoreContainer = fg('ptc-people-teams-migrate-styled-components')
		? (props: React.HTMLAttributes<HTMLDivElement>) => (
				<div css={compiledStyles.infoPopupLearnMoreWrapper} {...props} />
			)
		: Styled.InfoPopupLearnMoreWrapper;

	return (
		<InfoPopupLearnMoreContainer>
			{/* eslint-disable-next-line @atlassian/a11y/anchor-is-valid, @atlaskit/design-system/no-html-anchor */}
			<a target="_blank" rel="noreferrer" href="#">
				<FormattedMessage {...messages.learnMore} />
			</a>
		</InfoPopupLearnMoreContainer>
	);
}
export function TeamNameErrorMsg({ errorMsg }: { errorMsg: string }): React.JSX.Element {
	return <ErrorMessage testId="team-name-empty-error">{errorMsg}</ErrorMessage>;
}
export function TeamNameInfoMsg(): React.JSX.Element {
	const { formatMessage } = useIntl();

	// TODO: Remove wrappers after ptc-people-teams-migrate-styled-components FF cleanup
	const FlexContainer = fg('ptc-people-teams-migrate-styled-components')
		? (props: React.HTMLAttributes<HTMLDivElement>) => (
				<div css={compiledStyles.divWrapper} {...props} />
			)
		: Styled.DivWrapper;

	const InfoIconContainer = fg('ptc-people-teams-migrate-styled-components')
		? (props: React.HTMLAttributes<HTMLSpanElement>) => (
				<span css={compiledStyles.infoIconWrapper} {...props} />
			)
		: Styled.InfoIconWrapper;

	return (
		<HelperMessage testId="team-name-info-msg" aria-hidden="true">
			<FlexContainer>
				<FormattedMessage {...messages.teamNameFieldInfoMessage} />
				<Tooltip content={formatMessage(messages.teamNameFieldInfoDetail)}>
					<InfoIconContainer tabIndex={0} role="button">
						<EditorInfoIcon
							label={formatMessage(messages.teamNameFieldInfoDetail)}
							color="currentColor"
							size="small"
						/>
					</InfoIconContainer>
				</Tooltip>
			</FlexContainer>
		</HelperMessage>
	);
}
